import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'


export const warehouseManagement = {
  path: '/warehouseManagement/',
  name: 'warehouseManagement',
  component: LayoutWithSideMenu,
  meta: {
    title: '仓储管理'
  },
  children: [{
      path: 'materialLedger',
      name: 'materialLedger',
      component: () => import('@/views/warehouseManagement/materialLedger/index.vue'),
      meta: {
        title: '物料台账'
      }
    },{
    path: 'materialLedgerAll',
    name: 'materialLedgerAll',
    component: () => import('@/views/warehouseManagement/materialLedgerAll/index.vue'),
    meta: {
      title: '售后物料总台账'
    }
  },  {
      path: 'materialMaster',
      name: 'materialMaster',
      component: () => import('@/views/warehouseManagement/materialMaster/index.vue'),
      meta: {
        title: '物料主数据'
      }
    }, {
      path: 'toolLedger',
      name: 'toolLedger',
      component: () => import('@/views/warehouseManagement/toolLedger/index.vue'),
      meta: {
        title: '工具台账'
      }
    }, {
      path: 'toolMaster',
      name: 'toolMaster',
      component: () => import('@/views/warehouseManagement/toolMaster/index.vue'),
      meta: {
        title: '工具主数据'
      }
    },

  ]
}
